var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay-center-item-component",class:[
       ("pay-center-item-component--" + _vm.size)
     ],on:{"click":_vm.handleClick}},[_c('div',{staticClass:"pay-center-item-title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"pay-center-item-value",class:[
         { 'strong-value': _vm.strongValue } ]},[_vm._t("default"),(_vm.isLink)?_c('ym-icon',{staticClass:"pay-center-item-icon",attrs:{"name":"right"}}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }